export const summaryTableColumn = [{
    title: '利润分配',
    list: [
        {
            name: '营业总收入',
            value: 'operatingRevenue'
        },
        {
            name: '净利润',
            value: 'netProfit'
        },
        {
            name: '归母净利润',
            value: 'nPParentCompanyOwners'
        },
        {
            name: '营业利润',
            value: 'operatingProfit'
        },
        {
            name: '基本每股收益',
            value: 'basicEPS'
        },
        {
            name: '稀释每股收益',
            value: 'dilutedEPS'
        }]
},
{
    title: '资产负债',
    list: [
        {
            name: '资产总计',
            value: 'totalAssets'
        },
        {
            name: '负债合计',
            value: 'totalLiability'
        },
        {
            name: '所有者权益合并',
            value: 'totalShareholderEquity'
        },
        {
            name: '流动资产合计',
            value: 'totalCurrentAssets'
        },
        {
            name: '流动负债合计',
            value: 'totalCurrentLiability'
        },
        {
            name: '无形资产',
            value: 'tntangibleAssets'
        },
        {
            name: '商誉',
            value: 'goodWill'
        }
    ]
},
{
    title: '现金流量',
    list: [
        {
            name: '经营现金流量净额',
            value: 'netOperateCashFlow'
        },
        {
            name: '投资现金流量净额',
            value: 'netInvestCashFlow'
        },
        {
            name: '筹资现金流量净额',
            value:'netFinanceCashFlow'
        },
        {
            name: '现金及现金等价物余额',
            value: 'endPeriodCashEquivalent'
        },
        {
            name: '现金及现金等价物净增加额',
            value: 'endPeriodCashEquivalent'
        }
    ]
},
]
//利润表-明细
export let  profitCloumn = [
    {
        title: '',
        list:[
            {
                name:'营业总收入',
                bold:'bold',
                value:'totalOperatingRevenue'
            },
            {
                name:'营业收入',
                value:'operatingRevenue'
            },
            {
                name:'利息收入',
                value:'interestIncome'
            },
            {
                name:'营业总成本',
                value:'totalOperatingCost'
            },
            {
                name:'其中：营业成本',
                value:'operatingCost'
            },
            {
                name:'营业税金及附加',
                value:'operatingTaxSurcharges'
            },
            {
                name:'销售费用',
                value:'operatingExpense'
            },
            {
                name:'管理费用',
                value:'administrationExpense'
            },
            {
                name:'研发费用',
                value:'randD'
            },
            {
                name:'其中：利息费用',
                value:'interestFinExp'
            },
            {
                name:'利息收入',
                value:'interestIncomeFin'
            },
            {
                name:'加：公允价值变动收益',
                value:'fairValueChangeIncome'
            },
            {
                name:'投资收益',
                value:'investIncome'
            },
            {
                name:'资产处置收益',
                value:'assetDealIncome'
            },
            {
                name:'资产减值损失',
                value:'assetImpairmentLoss'
            },
            {
                name:'信用减值损失',
                value:'creditImpairmentL'
            },
            {
                name:'其他收益',
                value:'otherRevenue'
            },
            {
                name:'营业利润',
                value:'operatingProfit',
                bold:'bold'
            },
            {
                name:'加：营业外收入',
                value:'nonoperatingIncome'
            },
            {
                name:'减：营业外支出',
                value:'nonoperatingExpense'
            },
            {
                name:'利润总额',
                value:'totalProfit',
                 bold:'bold'
            },
            {
                name:'减：所得税费用',
                value:'incomeTaxCost'
            },
            {
                name:'净利润',
                value:'netProfit',
                 bold:'bold'
            },
            {
                name:'归属于母公司所有者的净利润',
                value:'npparentCompanyOwners'
            },
            {
                name:'少数股东损益',
                value:'minorityProfit'
            },
            {
                name:'基本每股收益',
                value:'basicEPS',
                 bold:'bold'
            },
            {
                name:'稀释每股收益',
                value:'dilutedEPS',
                 bold:'bold'
            },
            {
                name:'其他综合收益',
                value:'otherCompositeIncome',
                 bold:'bold'
            },
            {
                name:'归属于母公司所有者的其他综合收益',
                value:'ociparentCompanyOwners'
            },
            {
                name:'综合收益总额',
                value:'totalCompositeIncome',
                 bold:'bold'
            },
            {
                name:'归属于母公司所有者的综合收益总额',
                value:'ciparentCompanyOwners'
            },
            {
                name:'归属于少数股东的综合收益总额',
                value:'ciminorityOwners'
            },
           
        ]
    }
]

//现金流量表
export const cashFlowCloumn = [{
    title: '经营活动产生的现金流量',
    list: [
        {
            name: '销售商品、提供劳务收到的现金',
            value: 'goodsSaleServiceRenderCash'
        },
        {
            name: '客户存款和同业存放款项净增加额',
            value: 'netDepositIncrease	'
        },
        {
            name: '向中央银行借款净增加额',
            value: 'netBorrowingFromCentralBank'
        },
        {
            name: '向其他金融机构拆入资金净增加额',
            value: 'netBorrowingFromFinanceCo'
        },
        {
            name: '收到原保险合同保费取得的现金',
            value: 'netOriginalInsuranceCash'
        },
        {
            name: '收到再保险业务现金净额',
            value: 'netReinsuranceCash'
        },
        {
            name: '保户储金及投资款净增加额',
            value: 'netInsurerDepositInvestment	'
        },
        {
            name: '处置交易性金融资产净增加额',//
            value: 'netDealTradingAssets'
        },
      
        {
            name: '收取利息、手续费及佣金的现金',
            value: 'interestAndCommissionCashIn'
        },
        {
            name: '拆入资金净增加额',
            value: 'netIncBorFunds'
        },
        {
            name: '回购业务资金净增加额',
            value: 'netBuyBackFin'
        },
        {
            name: '收到的税费返还',
            value: 'taxLevyRefund	'
        },
        {
            name: '经营活动现金流入小计',
            value: 'subtotalOperateCashInflow'
        },
        {
            name: '购买商品、接受劳务支付的现金',
            value: 'goodsServicesCashPaid'
        },
        {
            name: '客户贷款及垫款净增加额',
            value: 'netLoanAndAdvanceIncrease'
        },
        {
            name: '存放中央银行和同业款项净增加额',
            value: 'netDepositInCBAndIB'
        },
        {
            name: '支付原保险合同赔付款项的现金',
            value: 'originalCompensationPaid	'
        },
        {
            name: '支付保单红利的现金',//
            value: 'policyDividendCashPaid'
        },
      
        {
            name: '支付给职工以及为职工支付的现金',
            value: 'staffBehalfPaid'
        },
        {
            name: '支付的各项税费',
            value: 'allTaxesPaid'
        },
        {
            name: '支付其他与经营活动有关的现金',//
            value: 'otherOperateCashPaid'
        },
      
        {
            name: '经营活动现金流出小计',
            value: 'subtotalOperateCashOutflow'
        },
        {
            name: '经营活动产生的现金流量净额',
            value: 'netOperateCashFlow'
        },
    ]
},
{
    title: '投资活动产生的现金流量',
    list: [
        {
            name: '收回投资收到的现金',
            value: 'investWithdrawalCash'
        },
        {
            name: '取得投资收益收到的现金',
            value: 'investproceeds'
        },
        {
            name: '处置固定资产、无形资产和其他长期资产收回的现金净额',
            value: 'fixIntanOtherAssetDispoCash'
        },
        {
            name: '处置子公司及其他营业单位收到的现金净额',
            value: 'netCashDealSubCompany'
        },
        {
            name: '收到其他与投资活动有关的现金',
            value: 'otherCashFromInvestAct'
        },
        {
            name: '购建固定资产、无形资产和其他长期资产支付的现金',
            value: 'fixIntanOtherAssetAcquiCash'
        },
        {
            name: '投资支付的现金',
            value: 'investCashPaid'
        },
        {
            name: '质押贷款净增加额',
            value: 'impawnedLoanNetIncrease'
        },
        {
            name: '取得子公司及其他营业单位支付的现金净额',
            value: 'netCashFromSubCompany'
        },
        {
            name: '投资活动现金流出小计',
            value: 'subtotalInvestCashOutflow'
        },
        {
            name: '投资活动产生的现金流量净额',
            value: 'netInvestCashFlow'
        },
    ]
},
{
    title: '筹建活动产生的现金流量',
    list: [
        {
            name: '吸收投资收到的现金',
            value: 'cashFromInvest'
        },
        {
            name: '其中:子公司吸收少数股东投资收到的现金',
            value: 'cashFromMinoSInvestSub'
        },
        {
            name: '取得借款收到的现金',
            value:'cashFromBorrowing'
        },
        {
            name: '发行债券收到的现金',
            value: 'cashFromBondsIssue'
        },
        {
            name: '收到其他与筹资活动有关的现金',
            value: 'otherFinanceActCash'
        },
        {
            name: '筹资活动现金流入小计',
            value: 'subtotalFinanceCashInflow'
        },
        {
            name: '偿还债务支付的现金',
            value: 'borrowingRepayment'
        },
        {
            name: '分配股利、利润或偿付利息支付的现金',
            value:'dividendInterestPayment'
        },
        {
            name: '其中:子公司支付给少数股东的股利、利润或偿付的利息',
            value: 'proceedsFromSubToMinoS'
        },
        {
            name: '支付其他与筹资活动有关的现金',
            value: 'otherFinanceActPayment'
        },
        {
            name: '筹资活动现金流出小计',
            value: 'subtotalFinanceCashOutflow'
        },
        {
            name: '筹资活动产生的现金流量净额',
            value: 'netFinanceCashFlow'
        },
        {
            name: '汇率变动对现金及现金等价物的影响',
            value:'exchanRateChangeEffect'
        },
        {
            name: '现金及现金等价物净增加额',
            value: 'cashEquivalentIncrease'
        },
        {
            name: '期初现金及现金等价物余额',
            value: 'beginPeriodCash'
        },
        {
            name: '现金的期末余额',
            value: 'cashAtEndOfYear'
        },
        {
            name: '减:现金的期初余额',
            value: 'cashAtBeginningOfYear'
        },
        {
            name: '现金等价物的期末余额',
            value:'cashEquivalentsAtEndOfYear'
        },
        {
            name: '现金等价物的期初余额',
            value: 'cashEquivalentsAtBeginning'
        },
        {
            name: '期末现金及现金等价物余额',
            value: 'endPeriodCashEquivalent'
        }
    ]
},
]
//资产负债表
export const flowCloumn = [{
    title: '流动资产',
    list: [
        {
            name: '货币资金',
            value: 'cashEquivalents'
        },
        {
            name: '结算备付金',
            value: 'settlementProvi	'
        },
        {
            name: '拆出资金',
            value: 'lendCapital'
        },
        {
            name: '交易性金融资产',
            value: 'tradingAssets'
        },
        {
            name: '买入返售金融资产',
            value: 'boughtSellbackAssets'
        },
        {
            name: '衍生金融资产',
            value: 'derivativeAssets'
        },
        {
            name: '应收票据及应收账款',
            value: 'billAccReceivable	'
        },
        {
            name: '应收票据',//
            value: 'billReceivable'
        },
      
        {
            name: '应收账款',
            value: 'accountReceivable'
        },
        {
            name: '应收款项融资',
            value: 'receivablesFin'
        },
        {
            name: '预付款项',
            value: 'advancePayment'
        },
        {
            name: '应收股利',
            value: 'dividendReceivable	'
        },
        {
            name: '应收利息',
            value: 'interestReceivable'
        },
        {
            name: '应收保费',
            value: 'insuranceReceivables'
        },
        {
            name: '应收分保账款',
            value: 'reinsuranceReceivables'
        },
        {
            name: '应收分保合同准备金',
            value: 'resReiReceContracts'
        },
        {
            name: '其他应收款',
            value: 'otherReceivable	'
        },
        {
            name: '其他应收款(含利息和股利)',//
            value: 'otherReceivableED'
        },
      
        {
            name: '存货',
            value: 'inventories'
        },
        {
            name: '划分为持有待售的资产',
            value: 'holdAndFSAssets'
        },
        {
            name: '待摊费用',//
            value: 'deferredExpense'
        },
      
        {
            name: '一年内到期的非流动资产',
            value: 'nonCurrentAssetIn1Year	'
        },
        {
            name: '其他流动资产',
            value: 'otherCurrentAssets'
        },
        {
            name: '流动资产合计',
            value: 'totalCurrentAssets'
        },
    ]
},
{
    title: '非流动资产',
    list: [
        {
            name: '发放贷款和垫款',
            value: 'loanAndAdvance'
        },
        {
            name: '债权投资',
            value: 'debtInvestment'
        },
        {
            name: '其他债权投资',
            value: 'othDebtInvestment'
        },
        {
            name: '可供出售金融资产',
            value: 'holdForSaleAssets'
        },
        {
            name: '长期股权投资',
            value: 'longtermEquityInvest'
        },
        {
            name: '投资性房地产',
            value: 'investmentProperty'
        },
        {
            name: '长期应收款',
            value: 'longtermReceivableAccount'
        },
        {
            name: '其他权益工具投资',
            value: 'othEquityInstrument'
        },
        {
            name: '其他非流动金融资产',
            value: 'othNonCurFinAssets'
        },
        {
            name: '固定资产',
            value: 'fixedAssets'
        },
        {
            name: '固定资产清理',
            value: 'fixedAssetsLiquidation'
        },
        {
            name: '在建工程',
            value: 'construInProcess'
        },
        {
            name: '工程物资',
            value: 'constructionMaterials'
        },
        {
            name: '生产性生物资产',
            value: 'biologicalAssets'
        },
        {
            name: '油气资产',
            value: 'oilGasAssets'
        },
        {
            name: '使用权资产',
            value: 'usufructAssets'
        },
        {
            name: '无形资产',
            value: 'intangibleAssets'
        },
        {
            name: '开发支出',
            value: 'developmentExpenditure'
        },
        {
            name: '商誉',
            value: 'goodWill'
        },
        {
            name: '长期待摊费用',
            value: 'longDeferredExpense'
        },
        {
            name: '递延所得税资产',
            value: 'deferredTaxAssets'
        },
        {
            name: '其他非流动资产',
            value: 'otherNonCurrentAssets'
        },
        {
            name: '非流动资产合计',
            value: 'totalNonCurrentAssets'
        },
    ]
},
{
    title: '流动负债',
    list: [
        {
            name: '短期借款',
            value: 'shortTermLoan'
        },
        {
            name: '向中央银行借款',
            value: 'borrowingFromCentralBank'
        },
        {
            name: '吸收存款及同业存款',
            value:'absInterDeposits'
        },
        {
            name: '拆入资金',
            value: 'borrowingCapital'
        },
        {
            name: '交易性金融负债',
            value: 'tradingLiability'
        },
        {
            name: '衍生金融负债',
            value: 'derivativeLiability'
        },
        {
            name: '应付票据及应付账款',
            value: 'notAccountsPayable'
        },
        {
            name: '应付票据',
            value:'notesPayable'
        },
        {
            name: '应付账款',
            value: 'accountsPayable'
        },
        {
            name: '预收款项',
            value: 'advanceReceipts'
        },
        {
            name: '合同负债',
            value: 'contractLiability'
        },
        {
            name: '卖出回购金融资产款',
            value: 'soldBuybackSecuProceeds'
        },
        {
            name: '应付手续费及佣金',
            value:'commissionPayable'
        },
        {
            name: '应付职工薪酬',
            value: 'salariesPayable'
        },
        {
            name: '应交税费',
            value: 'taxsPayable'
        },
        {
            name: '应付利息',
            value: 'interestPayable'
        },
        {
            name: '应付股利',
            value: 'dividendPayable'
        },
        {
            name: '其他应付款',
            value:'otherPayable'
        },
        {
            name: '其他应付款(含利息和股利)',
            value: 'otherPayableED'
        },
        {
            name: '应付分保账款',
            value: 'reinsurancePayables'
        },
        {
            name: '应付股利',
            value: 'dividendPayable'
        },
        {
            name: '其他应付款',
            value:'otherPayable'
        },
        {
            name: '其他应付款(含利息和股利)',
            value: 'otherPayableED'
        },
        {
            name: '应付分保账款',
            value: 'reinsurancePayables'
        },
        {
            name: '保险合同准备金',
            value:'insContractReserve'
        },
        {
            name: '代理买卖证券款',
            value: 'proxySecuProceeds'
        },
        {
            name: '代理承销证券款',
            value: 'subIssueSecuProceeds'
        },
        {
            name: '预提费用',
            value:'accruedExpense'
        },
        {
            name: '应付短期债券',
            value: 'stbondsPayable'
        },
        {
            name: '划分为持有待售的资产',
            value: 'holdAndFSAssets'
        },
        {
            name: '一年内到期的非流动负债',
            value:'nonCurrentAssetIn1Year'
        },
        {
            name: '其他流动负债',
            value: 'otherCurrentLiability'
        },
        {
            name: '流动负债合计',
            value: 'totalCurrentLiability'
        }
    ]
},
{
    title: '非流动负债',
    list: [
        {
            name: '长期借款',
            value: 'longtermLoan'
        },
        {
            name: '应付债券',
            value: 'bondsPayable'
        },
        {
            name: '应付债券：优先股',
            value:'lpreferStock'
        },
        {
            name: '应付债券：永续债',
            value: 'lPerpetualDebt'
        },
        {
            name: '租赁负债',
            value: 'leaseLiabilities'
        },
        {
            name: '长期应付职工薪酬',
            value: 'longSalariesPay'
        },
        {
            name: '长期应付款',
            value: 'longtermAccountPayable'
        },
        {
            name: '专项应付款',
            value:'specificAccountPayable'
        },
        {
            name: '预计非流动负债',//??
            value: ''
        },
        {
            name: '负债合计',
            value: 'totalLiability'
        },
       
    ]
},
{
    title: '所有者权益',
    list: [
        {
            name: '实收资本(或股本)',
            value: 'paidInCapital'
        },
        {
            name: '其他权益工具',
            value: 'otherEquityinstruments'
        },
        {
            name: '优先股',
            value:'ePreferStock'
        },
        {
            name: '永续债',
            value: 'ePerpetualDebt'
        },
        {
            name: '资本公积',
            value: 'capitalReserveFund'
        },
        {
            name: '减:库存股',
            value: 'treasuryStock'
        },
        {
            name: '其他综合收益',
            value: 'otherCompositeIncome'
        },
        {
            name: '专项储备',
            value:'specificReserves'
        },
        {
            name: '盈余公积',//??
            value: 'surplusReserveFund'
        },
        {
            name: '一般风险准备',
            value: 'ordinaryRiskReserveFund'
        },
        {
            name: '未确认投资损失',
            value: 'uncertainedInvestmentLoss'
        },
        {
            name: '未分配利润',
            value: 'retainedProfit'
        },
        {
            name: '外币报表折算差额',
            value: 'foreignCurrencyReportConvDiff'
        },
        {
            name: '归属母公司股东权益合计',
            value:'sEWithoutMI'
        },
        {
            name: '少数股东权益',//??
            value: 'minorityInterests'
        },
        {
            name: '所有者权益(或股东权益)合计',
            value: 'totalShareholderEquity'
        },
        {
            name: '负债和所有者权益(或股东权益)总计',
            value: 'totalLiabilityAndEquity'
        },
       
    ]
},
]